module.exports = __webpack_public_path__ + "img/chat-conversation-light.e6ecf092.svg";